import React from 'react'
import { SourceRailSkeleton } from '@fs/zion-source-list'
import CenteredLoadingSpinner from '../../../common/CenteredLoadingSpinner'
import useSourceCentricDetailsFlag from '../../../data-service/useSourceCentricDetailsFlag'

export default function SourcesCardSkeleton(): JSX.Element {
  const { data } = useSourceCentricDetailsFlag()
  const isSourceCentricOn = !!data?.isOn

  if (isSourceCentricOn) {
    return <SourceRailSkeleton />
  }

  return <CenteredLoadingSpinner />
}
